<template>
    <div class="config-call">
        <div class="table-config">
            <div class="list-configs">
                <div
                    class="config-item"
                    v-for="config in listConfigs"
                    :key="config.id"
                    :class="idConfigActive === config.id ? 'config-actived' : ''"
                    @click="idConfigActive = config.id"
                >
                    {{ config.name }}
                </div>
            </div>
            <div class="config-box fci-scrollbar">
                <NewQCStep1
                    ref="NewQCStep1"
                    v-show="idConfigActive === 'qc-info'"
                    :campaign-list="getListCampaigns()"
                    :is-setting="true"
                ></NewQCStep1>
                <NewQCStep2
                    ref="NewQCStep2"
                    v-show="idConfigActive === 'qc-data-input'"
                    :hide-footer="true"
                ></NewQCStep2>
                <NewQCStep3
                    ref="NewQCStep3"
                    v-show="idConfigActive === 'qc-criteria'"
                    :hide-footer="true"
                    @updateCriteria="updateCriteria"
                ></NewQCStep3>
                <NewQCStep4
                    ref="NewQCStep3"
                    v-show="idConfigActive === 'qc-asr-criteria'"
                    :hide-footer="true"
                    @updateAsrCriteria="updateAsrCriteria"
                ></NewQCStep4>
                <QCReportMetric
                    ref="QCReportMetric"
                    v-show="idConfigActive === 'qc-report-metrics'"
                ></QCReportMetric>
            </div>
        </div>
    </div>
</template>

<script>
import {mapState} from "vuex";
import NewQCStep1 from "@/views/QualityControl/Form/NewQCStep1";
import NewQCStep2 from "@/views/QualityControl/Form/NewQCStep2";
import NewQCStep3 from "@/views/QualityControl/Form/NewQCStep3";
import NewQCStep4 from "@/views/QualityControl/Form/NewQCStep4";
import CampaignService from "@/services/campaign.service";
import QCReportMetric from "@/views/QualityControl/QCReportMetric.vue";

export default {
    name: "QCSetting",
    components: {
        QCReportMetric,
        NewQCStep1,
        NewQCStep2,
        NewQCStep3,
        NewQCStep4
    },
    data() {
        return {
            idConfigActive: "",
            chooseCampaignList: []
        };
    },
    computed: {
        ...mapState({
            qcCampaign: state => state.qccampaign.campaign,
            campaignList: state => state.qccampaign.callCampaigns,
        }),
        listConfigs() {
            return [
                {
                    id: "qc-info",
                    name: this.$f.tc("qcInfo")
                },
                {
                    id: "qc-data-input",
                    name: this.$f.tc("qcDataInput")
                },
                {
                    id: "qc-criteria",
                    name: this.$f.tc("qcCriteria")
                },
                {
                    id: "qc-asr-criteria",
                    name: this.$f.tc("qcAsrCriteria")
                },
                {
                    id: "qc-report-metrics",
                    name: this.$f.tc("qcReportMetrics")
                }
            ];
        }
    },
    mounted() {
        this.idConfigActive = "qc-info";
    },
    methods: {
        getListCampaigns() {
           return  this.campaignList.filter(i =>
                i.permissions.includes("admin"))
        },
        updateAsrCriteria(data) {
            this.$emit("updateAsrCriteria", data);
        },
        updateCriteria(data) {
            this.$emit("updateCriteria", data);
        }
    }
};
</script>
<style scoped lang="scss">
::v-deep {
    .v-card__title {
        font-size: 16px;
        font-weight: bold;
    }

    .title-config {
        .title {
            font-family: "open sans bold", serif !important;
            text-transform: capitalize;
        }
    }
}

.config-call {
    font-family: "open sans", serif !important;
}

.table-config {
    display: flex;

    .list-configs {
        font-size: 14px;
        border-right: 1px solid #E4EDFA;
    }

    .config-actived {
        background: #e4edfa;
        font-weight: 700;
        color: #0052cc;
    }

    .config-item {
        height: 44px;
        line-height: 44px;
        padding: 0 12px;
        cursor: pointer;
        border-bottom: 1px solid #E4EDFA;
        text-transform: capitalize;
        width: 300px;

        &:hover {
            background: #F5F5F5;
        }
    }

    .config-box {
        flex: 1;
        height: calc(100vh - 195px);
        overflow-y: auto;
    }
}

.step-actions {
    margin-top: 24px;
}

.config-content {
    padding: 20px;
    height: calc(100vh - 576px);
    overflow-y: auto;
}

.NewQCStep3 {
    ::v-deep textarea {
        padding: 10px;
        overflow-y: auto;
        margin: 0 !important;
        font-size: 14px;
    }
}

.NewQCStep4 {
    ::v-deep textarea {
        padding: 10px;
        overflow-y: auto;
        margin: 0 !important;
        font-size: 14px;
    }
}
</style>
